// extracted by mini-css-extract-plugin
export default {"titleSection":"LandingPageHeader_titleSection__uUcMt","title":"LandingPageHeader_title__DzFnL","explanation":"LandingPageHeader_explanation__B4bmZ"};